import { Icon, MenuSelect, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { useRateManagementActions } from '../../../../store/rateManagement/actions';

export namespace RateManagementPillButtonTypes {
  export interface Props {
    handlePress?: () => void;
  }
}
export const PillButton: React.FC<RateManagementPillButtonTypes.Props> = ({ handlePress }) => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { downloadSpreadsheet } = useRateManagementActions();

  const contentReponsive = useBreakpointValue({
    base: (
      <Pressable
        onPress={handlePress}
        flexDirection={'row'}
        paddingLeft={Spacing['inline.xxxs']}
        paddingY={Spacing['inset.quarck']}
        borderRadius="2xl"
        alignItems="center"
        justifyContent="space-between">
        <Text
          pt="2px"
          color={Utils.Responsive.All({
            phone: 'brand.tertiary.principal',
            tablet: 'neutral.black',
            desktop: 'neutral.black',
          })}
          pr="4px"
          fontSize={Typography['fontsize.md']}
          variant="semibold">
          NOVA SOLICITAÇÃO
        </Text>
        <Icon
          name="Addition"
          testId="addition-icon"
          color={Color['brand.tertiary.principal']}
          size="xxs"
        />
      </Pressable>
    ),
    sm: (
      <Box marginBottom={-2}>
        <MenuSelect
          triggerComponent={
            <HStack
              shadow={1}
              backgroundColor={Utils.Responsive.All({
                phone: 'transparent',
                tablet: Color['neutral.white'],
                desktop: Color['neutral.white'],
              })}
              width="100%"
              paddingLeft={Spacing['inline.xxxs']}
              paddingRight={Spacing['inline.nano']}
              paddingY={Spacing['inset.quarck']}
              borderRadius="2xl"
              justifyContent="space-between">
              <Text
                pt="2px"
                color={Utils.Responsive.All({
                  phone: 'brand.tertiary.principal',
                  tablet: 'neutral.black',
                  desktop: 'neutral.black',
                })}
                pr="4px"
                fontSize={Typography['fontsize.md']}
                variant="semibold">
                NOVA SOLICITAÇÃO
              </Text>
              <Icon
                name="Addition"
                testId="addition-icon"
                color={Color['neutral.black']}
                size="xxs"
              />
            </HStack>
          }
          items={[
            {
              label: 'IMPORTAR PLANILHA',
              icon: 'Upload' as IconographyTypes.Option,
              onPress: () => {
                navigation.navigate('RateManagementUpload');
              },
            },
            {
              label: 'EXPORTAR PLANILHA',
              icon: 'Download' as IconographyTypes.Option,
              onPress: () => {
                downloadSpreadsheet();
              },
            },
          ]}
        />
      </Box>
    ),
  });

  return contentReponsive;
};
